/* eslint-disable max-len */

export default function Rectangle6Icon() {
    return (
        <svg id="a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
            <path
                d="M10,12v-4c0-1.654,1.346-3,3-3h2c1.654,0,3,1.346,3,3v4c0,.552-.447,1-1,1h-6c-.553,0-1-.448-1-1ZM27,13c.553,0,1-.448,1-1v-4c0-1.654-1.346-3-3-3h-2c-1.654,0-3,1.346-3,3v4c0,.552.447,1,1,1h6ZM35,5h-2c-1.654,0-3,1.346-3,3v4c0,.552.447,1,1,1h6c.553,0,1-.448,1-1v-4c0-1.654-1.346-3-3-3ZM37,35h-6c-.553,0-1,.448-1,1v4c0,1.654,1.346,3,3,3h2c1.654,0,3-1.346,3-3v-4c0-.552-.447-1-1-1ZM23,43h2c1.654,0,3-1.346,3-3v-4c0-.552-.447-1-1-1h-6c-.553,0-1,.448-1,1v4c0,1.654,1.346,3,3,3ZM18,36c0-.552-.447-1-1-1h-6c-.553,0-1,.448-1,1v4c0,1.654,1.346,3,3,3h2c1.654,0,3-1.346,3-3v-4ZM35,15H13c-1.654,0-3,1.346-3,3v12c0,1.654,1.346,3,3,3h22c1.654,0,3-1.346,3-3v-12c0-1.654-1.346-3-3-3Z"
                fill="#D9D9D9"
            />
        </svg>
    );
}
